import { StyleSheet } from 'aphrodite';
import { aceGray, background, brandPrimary, charmGray, destructive, white } from '../../../styles/colors';

export const s = StyleSheet.create({
	container: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	hiddenInput: {
		display: 'none',
	},
	dropZone: {
		border: `2px dashed ${aceGray}`,
		borderRadius: 8,
		padding: 24,
		textAlign: 'center',
		cursor: 'pointer',
		backgroundColor: background,
		transition: 'all 0.2s ease',
		':hover': {
			borderColor: brandPrimary,
			backgroundColor: '#f8fafc',
		},
	},
	dropZoneDragging: {
		borderColor: brandPrimary,
		backgroundColor: '#f0f7ff',
	},
	dropZoneContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		alignItems: 'center',
	},
	dropZoneText: {
		fontSize: 14,
		color: charmGray,
		fontWeight: 500,
	},
	dropZoneHint: {
		fontSize: 12,
		color: charmGray,
	},
	thumbnailContainer: {
		display: 'flex',
		gap: 12,
		flexWrap: 'wrap',
	},
	thumbnail: {
		position: 'relative',
		width: 120,
		height: 120,
		borderRadius: 8,
		overflow: 'hidden',
		border: `1px solid ${aceGray}`,
		backgroundColor: white,
		display: 'flex',
		flexDirection: 'column',
	},
	thumbnailImage: {
		width: '100%',
		height: 80,
		objectFit: 'cover',
	},
	removeButton: {
		position: 'absolute',
		top: 4,
		right: 4,
		width: 20,
		height: 20,
		borderRadius: 4,
		backgroundColor: 'rgba(0, 0, 0, 0.6)',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 0,
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: destructive,
		},
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
	},
	removeIcon: {
		width: 12,
		height: 12,
		color: white,
	},
	thumbnailInfo: {
		padding: '4px 8px',
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		flex: 1,
		justifyContent: 'center',
	},
	thumbnailName: {
		fontSize: 11,
		color: charmGray,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontWeight: 500,
	},
	thumbnailSize: {
		fontSize: 10,
		color: charmGray,
	},
});
